import React from "react";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="page legal-page">
      <section className="page-section legal-hero">
        <p className="eyebrow">Terms · Website use</p>
        <h1>Terms of use.</h1>
        <p className="hero-intro">These terms govern use of the public Birdwatcher website operated by Agroadviser Solutions Kft. They apply to the website and its informational content, not to separately contracted customer services or deployments.</p>
      </section>

      <section className="page-section compact-section legal-content">
        <article>
          <span className="section-label">01 · Operator</span>
          <h2>Who operates this website?</h2>
          <p>Birdwatcher is a project of Agroadviser Solutions Kft., registered at 3700 Kazincbarcika, Rózsa út 57., Hungary. Company registration number: 05-09-039444. Tax number: 32943805-2-05.</p>
          <p>Full company and contact information is available in the <Link to="/imprint">Imprint</Link>.</p>
        </article>

        <article>
          <span className="section-label">02 · Informational purpose</span>
          <h2>No offer or operational guarantee</h2>
          <p>The website describes research, concepts, demonstrations, measurements and project capabilities for general informational purposes. Unless explicitly stated in a separate written agreement, website content does not constitute a binding commercial offer, warranty, service-level commitment or guarantee of performance in a particular farm, flock or operating environment.</p>
        </article>

        <article>
          <span className="section-label">03 · Technical and scientific content</span>
          <h2>Results depend on context</h2>
          <p>Measurements, simulations, model performance and examples may depend on biological conditions, sampling, hardware, calibration, deployment, data quality and other field-specific factors. They should not be interpreted as universally reproducible results.</p>
          <p>Users remain responsible for professional, operational, veterinary, regulatory and commercial decisions made on the basis of information available on this public website.</p>
        </article>

        <article>
          <span className="section-label">04 · Intellectual property</span>
          <h2>Content and project materials</h2>
          <p>Unless otherwise indicated, the website design, text, graphics, project descriptions, visualisations and other original materials are owned by or lawfully used by Agroadviser Solutions Kft. They may be viewed and shared by linking to the website, but may not be reproduced, republished, sold, modified or used commercially without permission where such permission is required by law.</p>
        </article>

        <article>
          <span className="section-label">05 · Acceptable use</span>
          <h2>Use the site lawfully</h2>
          <p>You must not use the website to interfere with its operation, attempt unauthorised access, submit malicious payloads, circumvent technical controls, impersonate another person, or use contact functionality for spam, harassment or unlawful purposes.</p>
        </article>

        <article>
          <span className="section-label">06 · External services and links</span>
          <h2>Third-party resources</h2>
          <p>The website may refer or link to third-party services, publications or resources. Agroadviser does not control those external services and is not responsible for their availability, content, privacy practices or terms.</p>
        </article>

        <article>
          <span className="section-label">07 · Availability and changes</span>
          <h2>The project evolves</h2>
          <p>Birdwatcher is actively developed. Website functions, project descriptions, demonstrations and availability may be changed, suspended or removed. We may update these terms when the website or applicable requirements change.</p>
        </article>

        <article>
          <span className="section-label">08 · Privacy</span>
          <h2>Personal data</h2>
          <p>Processing of personal data through this website is described separately in our <Link to="/privacy">Privacy & data protection notice</Link>. The contact and newsletter forms remain disabled until their configured backend services are enabled.</p>
        </article>

        <article>
          <span className="section-label">09 · Applicable law</span>
          <h2>Governing framework</h2>
          <p>These website terms are governed by Hungarian law, subject to any mandatory rules that apply to a particular user or relationship. Contracted customer projects and services are governed by their own agreements.</p>
        </article>

        <article>
          <span className="section-label">10 · Contact</span>
          <h2>Questions about these terms</h2>
          <p>Contact Agroadviser Solutions Kft. at <a href="mailto:info@agroadvisor.hu">info@agroadvisor.hu</a> or by phone at <a href="tel:+36301634341">+36 30 163 4341</a>.</p>
        </article>
      </section>
    </div>
  );
}
